import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { AuthGuard } from '../auth/auth.guard';
import { IsSelfOrIsAdminGuard } from '../auth/is-self-or-is-admin.guard';

const routes: Routes = [
    {
        path: ':id',
        component: UserProfileComponent,
        canActivate: [AuthGuard, IsSelfOrIsAdminGuard]
    },
    {
        path: '**',
        redirectTo: '/home'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UsersRoutingModule {}
